import UserGroup from 'types/userGroup';
import axios from 'utils/axios';

export default class UserGroupService {
    async getUserGroups(tenantId: string): Promise<UserGroup[]> {
        try {
            const result = await axios.post<UserGroup[]>('/GetUserGroups', tenantId);
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch user groups');
        }
    }

    async addUserGroup(name: string, tenantId: string): Promise<string> {
        try {
            const result = await axios.post<string>('/AddUserGroup', { name, tenantId });
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to add user group');
        }
    }

    async deleteUserGroup(groupId: string): Promise<boolean> {
        try {
            await axios.post('/DeleteUserGroup', groupId);
            return true;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to delete user group');
        }
    }

    async addAssetToGroup(assetId: string, userGroupId: string): Promise<string> {
        try {
            const result = await axios.post<string>('/AddAssetToGroup', { assetId, userGroupId });
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to add asset to group');
        }
    }

    async removeAssetFromGroup(assetUserGroupId: string): Promise<boolean> {
        try {
            await axios.post('/RemoveAssetFromGroup', assetUserGroupId);
            return true;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to remove asset from group');
        }
    }

    async addUserToGroup(userId: string, tenantId: string, userGroupId: string): Promise<string> {
        try {
            const result = await axios.post<string>('/AddUserToGroup', { userId, tenantId, userGroupId });
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to add user to group');
        }
    }

    async removeUserFromGroup(userTenantUserGroupId: string): Promise<boolean> {
        try {
            await axios.post('/RemoveUserFromGroup', userTenantUserGroupId);
            return true;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to remove user from group');
        }
    }
}
